<template>

  <div>
    <transition name="slide" mode="out-in">
        <router-view></router-view>
    </transition>
  </div>

</template>

<script>

import workflowMixin from '../../mixins/workflow';

export default {
  props: ['currentWorkflow'],
  mixins: [workflowMixin],
  mounted() {
    this.$router.app.$on('navigateToNextStep', this.onNavigateToNextStep);
    this.$router.app.$on('navigateToPreviousStep', this.onNavigateToPreviousStep);
  },
  methods: {
    onNavigateToNextStep() {
      const currentIndex = this.workflowSummary.currentStep;
      const nextIndex = currentIndex + 1;

      if (nextIndex < this.workflowSummary.totalSteps) {
        const nextRoute = this.workflowSummary.allSteps[nextIndex];
        this.$router.push({ name: nextRoute });
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    },
    onNavigateToPreviousStep() {
      const currentIndex = this.workflowSummary.currentStep;
      const previousIndex = currentIndex - 1;

      if (previousIndex >= 0) {
        const nextRoute = this.workflowSummary.allSteps[previousIndex];
        this.$router.push({ name: nextRoute });
      }
    }
  },
  computed: {
    workflowSummary() {
      return this.retrieveWorkflowSummary(this.currentWorkflow);
    }
  }
};
</script>
